import { render } from "./product-page.vue?vue&type=template&id=4baf9594&scoped=true"
import script from "./product-page.vue?vue&type=script&lang=js"
export * from "./product-page.vue?vue&type=script&lang=js"

import "./product-page.vue?vue&type=style&index=0&id=4baf9594&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4baf9594"]])

export default __exports__